import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    edit: 'Adjust my income',
    isPaid:
      'Contributions over this period have been paid. Only ongoing and late payment periods can be edited.',
  },
  fr: {
    edit: 'Ajuster mes revenus',
    isPaid:
      'Les cotisations sur cette période ont été payées. Seules les périodes en cours et en attente de paiement peuvent être éditées.',
  },
} as const);

export default locales;
